module.exports = __webpack_public_path__ + "assets/9242c5276cafc9de11ebbfd914a16c20.mp3";